<!--五馆-预约专属研学-研学活动详情（参考用户端 excursionInfo）-->
<template>
    <div class="ex-info-container" v-loading="loading">
        <div class="ex-museum-title-container">
            <div class="ex-l-title">
                <div class="ex-l-t-title">{{ form.excursionTitle || '研学活动详情' }}</div>
                <div class="ex-l-b-title">预约专属研学</div>
            </div>
            <div class="ex-r-title">
                <div class="ex-back-btn" @click="backPage">⇦返回</div>
            </div>
        </div>

        <!-- 主内容区 -->
        <div class="ex-info-main">
            <!-- 一、活动基本信息 -->
            <div class="ex-info-section-title">一、活动基本信息</div>
            <div class="ex-info-line">
                <span class="ex-line-label">1.活动主题：</span>{{ form.excursionTheme || '--' }}
            </div>
            <div class="ex-info-line">
                <span class="ex-line-label">2.参与对象：</span>{{ form.excursionAudienceName || '--' }} 学生
            </div>
            <div class="ex-info-line">
                <span class="ex-line-label">3.活动时间：</span>{{ formatTimeRange() }}
            </div>
            <div class="ex-info-line">
                <span class="ex-line-label">4.活动地点：</span>{{ form.excursionAddress || '--' }}
            </div>

            <!-- 二、研学核心内容 -->
            <div class="ex-info-section-title">二、研学核心内容</div>
            <div class="ex-info-line">
                <span class="ex-line-label">1.知识研学：</span>{{ form.knowledgeExcursion || '--' }}
            </div>
            <div class="ex-info-line">
                <span class="ex-line-label">2.实践体验：</span>{{ form.practicalExperience || '--' }}
            </div>
            <div class="ex-info-line">
                <span class="ex-line-label">3.素养提升：</span>{{ form.qualityImprove || '--' }}
            </div>
            <div class="ex-info-line">
                <span class="ex-line-label">4.安全保障：</span>{{ form.safetyAssurance || '--' }}
            </div>

            <!-- 三、活动介绍 -->
            <div class="ex-info-section-title">三、活动介绍</div>
            <div class="ex-overview" v-html="form.excursionOverview"></div>

            <!-- 四、研学手册 -->
            <div class="ex-info-section-title">四、研学手册</div>
            <div class="ex-file-list" v-if="fileList.length > 0">
                <div class="ex-file-item" v-for="(item, index) in fileList" :key="index">
                    <div class="ex-file-name" @click="handleDownload(item)">{{ item.fileName }}</div>
                    <div class="ex-file-actions">
                        <div class="ex-file-action" title="预览" v-if="item.imgUrl">
                            <el-image @click="handleFileStatus(item.status)" class="ex-file-icon"
                                      :src="require('@/assets/file/file_view_color.png')"
                                      :preview-src-list="gainFileImgList(item.imgUrl, item.pages)">
                            </el-image>
                        </div>
                        <div class="ex-file-action" title="下载" @click="handleDownload(item)">
                            <img class="ex-file-icon" src="@/assets/file/file_download.png" alt="下载" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="ex-no-file" v-else>暂无附件</div>

            <!-- 五、联系方式 -->
            <template v-if="form.contactInfo">
                <div class="ex-info-section-title">五、联系方式</div>
                <div class="ex-info-line" style="white-space: pre-wrap;">{{ form.contactInfo }}</div>
            </template>

            <!-- 底部占位 -->
            <div class="ex-bottom-spacer"></div>
        </div>
    </div>
</template>

<script>
import { infoExcursion } from "@/api/admin/museum";
import { timestampDate2 } from "@/utils/date";
import { downloadFile } from "@/api/adminservice/public";

export default {
    name: "excursionInfo",
    components: {},
    data() {
        return {
            loading: false,
            form: {},
            fileList: [],
        }
    },
    props: {
        excursionId: {
            type: [String, Number],
            default: null
        },
    },
    watch: {
        excursionId() {
            this.queryExcursionInfo();
        },
    },
    created() {
        this.queryExcursionInfo();
    },
    methods: {
        /* ===============查询研学活动详情===================== */
        queryExcursionInfo() {
            if (!this.excursionId) return;
            this.loading = true;
            infoExcursion({ excursionId: this.excursionId }).then(res => {
                this.loading = false;
                if (res.data.code === 1) {
                    this.form = res.data.data || {};
                    this.fileList = [];
                    if (this.form.fileList && this.form.fileList.length > 0) {
                        this.fileList = this.form.fileList;
                    } else if (this.form.fileUrls) {
                        this.form.fileUrls.split(',').forEach(e => {
                            this.fileList.push({
                                fileName: e.substring(e.lastIndexOf('/') + 1),
                                fileUrl: e,
                            })
                        })
                    }
                } else {
                    this.$message.error(res.data.msg || "操作失败");
                }
            }).catch(() => {
                this.loading = false;
            });
        },
        /* ===============返回===================== */
        backPage() {
            this.$emit('back-page');
        },
        /* ===============工具方法===================== */
        formatTimeRange() {
            const begin = this.form.beginTime ? timestampDate2(Number(this.form.beginTime)) : '';
            const end = this.form.endTime ? timestampDate2(Number(this.form.endTime)) : '';
            if (begin && end) return begin + '--' + end;
            return begin || end || '--';
        },
        /* ===============文件操作===================== */
        handleDownload(item) {
            downloadFile(item.fileUrl, item.fileName);
        },
        handleFileStatus(status) {
            if (status === 1) {
            } else {
                this.$message.info("文件正在处理，请稍后刷新预览")
            }
        },
        gainFileImgList(baseUrl, page) {
            const list = [];
            for (let i = 1; i <= page; i++) {
                list.push(baseUrl + '/' + i + '.png');
            }
            return list;
        },
    }
}
</script>

<style scoped>
.ex-info-container {
    width: 100%;
    height: calc(100vh - 174px);
    background: #ffffff;
    border-radius: 16px;
    padding: 20px 28px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

.ex-museum-title-container {
    flex-shrink: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    row-gap: 10px;
    margin-bottom: 14px;
}

.ex-l-title {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.ex-l-t-title {
    font-weight: bold;
    color: #ff7f2e;
    font-size: 18px;
    line-height: 1.4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.ex-l-b-title {
    color: #9a9a9a;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.ex-r-title {
    flex-shrink: 0;
    margin-left: auto;
    display: flex;
    align-items: center;
}

.ex-back-btn {
    flex-shrink: 0;
    height: 32px;
    padding: 0 14px;
    background: #ff7f2e;
    color: #fff;
    line-height: 32px;
    text-align: center;
    font-size: 14px;
    border-radius: 6px;
    cursor: pointer;
    white-space: nowrap;
}

/* 主内容区 */
.ex-info-main {
    width: 100%;
    margin: 0 auto;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 6px;
    box-sizing: border-box;
}

.ex-info-main::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

.ex-info-main::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 6px;
}

.ex-info-main::-webkit-scrollbar-thumb {
    background: #ff7f2e;
    border-radius: 6px;
    border: 3px solid #f1f1f1;
}

.ex-bottom-spacer {
    width: 100%;
    height: 30px;
    flex-shrink: 0;
}

.ex-info-section-title {
    font-size: 17px;
    font-weight: bold;
    color: #ff7f2e;
    letter-spacing: 1px;
    margin: 24px 0 14px 0;
}

.ex-info-section-title:first-child {
    margin-top: 0;
}

.ex-info-line {
    width: 100%;
    font-size: 15px;
    color: #1f2937;
    line-height: 1.8;
    margin-bottom: 8px;
    padding-left: 20px;
    box-sizing: border-box;
}

.ex-line-label {
    font-weight: bold;
    color: #1f2937;
}

.ex-overview {
    width: 100%;
    font-size: 15px;
    color: #1f2937;
    line-height: 1.8;
    padding-left: 20px;
    box-sizing: border-box;
}

.ex-overview :deep(img) {
    max-width: 100%;
}

.ex-overview :deep(table) {
    width: 100%;
    border-collapse: collapse;
}

/* 研学手册 */
.ex-file-list {
    width: 100%;
    padding-left: 20px;
    box-sizing: border-box;
}

.ex-file-item {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #ff7f2e;
    box-sizing: border-box;
}

.ex-file-name {
    font-size: 15px;
    font-weight: bold;
    color: #1f2937;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.ex-file-name:hover {
    color: #ff7f2e;
}

.ex-file-actions {
    display: flex;
    align-items: center;
    gap: 14px;
    flex-shrink: 0;
}

.ex-file-action {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.ex-file-icon {
    width: 20px;
    height: 20px;
}

.ex-no-file {
    width: 100%;
    font-size: 14px;
    color: #9ca3af;
    padding-left: 20px;
    box-sizing: border-box;
}
</style>
